import React from 'react';
import Editor from 'react-simple-wysiwyg';

export default function App({ value, onChange }) {
  return <Editor value={value} onChange={(e) => onChange(e.target.value)} />;
}
